const API_BASE = '/api/rewards';
const SESSION_STORAGE_KEY = 'jz_rewards_session_v1';
const CSRF_STORAGE_KEY = 'jz_rewards_csrf_v1';

let csrfToken = null;
let sessionToken = null;

function readStorage(key) {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(key) || null;
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  if (typeof window === 'undefined') return;
  try {
    if (value) window.localStorage.setItem(key, value);
    else window.localStorage.removeItem(key);
  } catch {
    // ignore quota / private mode
  }
}

function loadPersistedAuth() {
  if (!sessionToken) sessionToken = readStorage(SESSION_STORAGE_KEY);
  if (!csrfToken) csrfToken = readStorage(CSRF_STORAGE_KEY);
}

function persistSession(token) {
  sessionToken = token || null;
  writeStorage(SESSION_STORAGE_KEY, sessionToken);
}

function persistCsrf(token) {
  if (!token) return;
  csrfToken = token;
  writeStorage(CSRF_STORAGE_KEY, csrfToken);
}

function getCsrfToken() {
  loadPersistedAuth();
  if (csrfToken) return csrfToken;
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)rewards_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function getSessionToken() {
  loadPersistedAuth();
  return sessionToken;
}

async function rewardsFetch(path, options = {}) {
  loadPersistedAuth();

  const method = options.method || 'GET';
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (method !== 'GET' && method !== 'HEAD') {
    const token = getCsrfToken();
    if (token) headers['X-CSRF-Token'] = token;
  }

  const bearer = getSessionToken();
  if (bearer) {
    headers.Authorization = `Bearer ${bearer}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    method,
    headers,
    credentials: 'include',
  });

  let data = null;
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    data = await res.json();
  }

  if (!res.ok) {
    if (res.status === 401) {
      clearRewardsClientState();
    }
    const err = new Error(data?.error || 'Request failed');
    err.status = res.status;
    throw err;
  }

  if (data?.csrfToken) {
    persistCsrf(data.csrfToken);
  }
  if (data?.sessionToken) {
    persistSession(data.sessionToken);
  }

  return data;
}

export function sendRewardsOtp(phone) {
  return rewardsFetch('/auth/send-otp', {
    method: 'POST',
    body: JSON.stringify({ phone }),
  });
}

export function verifyRewardsOtp({ phone, otpSessionId, code }) {
  return rewardsFetch('/auth/verify-otp', {
    method: 'POST',
    body: JSON.stringify({ phone, otpSessionId, code }),
  });
}

export function logoutRewards() {
  return rewardsFetch('/auth/logout', { method: 'POST' }).finally(() => {
    clearRewardsClientState();
  });
}

export function fetchRewardsMe() {
  return rewardsFetch('/me');
}

export function redeemReward(optionId) {
  return rewardsFetch('/redeem', {
    method: 'POST',
    body: JSON.stringify({ optionId }),
  });
}

export function saveRewardsBirthday({ month, day }) {
  return rewardsFetch('/birthday', {
    method: 'POST',
    body: JSON.stringify({ month, day }),
  });
}

export function clearRewardsClientState() {
  csrfToken = null;
  sessionToken = null;
  writeStorage(SESSION_STORAGE_KEY, null);
  writeStorage(CSRF_STORAGE_KEY, null);
}
